import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Grid, TextField, Typography, MenuItem, FormControlLabel, Switch } from "@material-ui/core";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { injectIntl } from "react-intl";
const useStyles = makeStyles(theme => ({
    card: {
        backgroundColor: "#fff",
        borderRadius: 8,
        paddingTop: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
        [theme.breakpoints.down("sm")]: {
            paddingTop: 8,
            paddingLeft: 0,
            paddingRight: 0
        }
    },
    header: {
        paddingLeft: 12,
        paddingRight: 12,
        paddingBottom: 6,
        marginBottom: 24,
        alignItems: "center",
        display: "flex"
    }
}));
addRegisteredSectionLayout({
    name: "SectionsWithSteppers",
    displayName: "SectionsWithSteppers",
    settings: {}
});
var LoanTypeEnum;
(function (LoanTypeEnum) {
    LoanTypeEnum["car"] = "Car loan";
    LoanTypeEnum["student"] = "Student loan";
})(LoanTypeEnum || (LoanTypeEnum = {}));
const SectionsWithSteppers = injectIntl((props) => {
    const { className } = props;
    const classes = useStyles();
    const loans = [
        {
            cash: "500000",
            bank: "Lånekassen",
            type: LoanTypeEnum.student,
            account: "2222 5555"
        },
        {
            cash: "300000",
            bank: "Santander Consumer Bank",
            type: LoanTypeEnum.car,
            account: "4695 0920"
        }
    ];
    return (_jsx(Grid, { container: true, spacing: 3, className: clsx(className, classes.card), direction: "column", children: loans.map((l, i) => (_jsx(LoanItem, { loan: l, idx: i }, l.account))) }));
});
const LoanItem = (props) => {
    const { loan, idx } = props;
    const [cashVal, setCashVal] = useState(loan.cash);
    const [typeVal, setTypeVal] = useState(loan.type.toString());
    const [refiVal, setRefiVal] = useState(true);
    return (_jsxs(Grid, { item: true, container: true, direction: "row", children: [_jsx(Grid, { item: true, container: true, style: {
                    borderRadius: "50%",
                    backgroundColor: "#ABDCBC",
                    width: 48,
                    height: 48,
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 20,
                    marginRight: 36
                }, children: _jsx(Typography, { children: idx + 1 }) }), _jsx(Grid, { item: true, children: _jsxs(Grid, { container: true, direction: "column", children: [_jsx(Grid, { item: true, children: _jsxs(Typography, { variant: "caption", children: [loan.bank, " - Account **", loan.account.substring(loan.account.length - 4, loan.account.length)] }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { placeholder: "Remaining loan amount", variant: "outlined", value: cashVal, onChange: e => setCashVal(e.target.value) }) }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "caption", children: "Loan type" }) }), _jsx(Grid, { item: true, xs: 4, children: _jsx(TextField, { select: true, variant: "outlined", value: typeVal, onChange: e => setTypeVal(e.target.value), style: { width: 223 }, children: Object.values(LoanTypeEnum).map(x => (_jsx(MenuItem, { value: x, children: x }, x))) }) }), _jsx(Grid, { item: true, children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: !!refiVal, onChange: e => setRefiVal(e.target.checked) }), label: "This loan should be fulfilled upon refinancing" }) })] }) })] }));
};
SectionsWithSteppers.displayName = "SectionsWithSteppers";
export { SectionsWithSteppers };
//# sourceMappingURL=SectionsWithSteppers.js.map